import {
  combineReducers,
  Reducer
} from 'redux';
import {
  FavoritesReducer,
  FavoritesState
} from '../favourites/redux/favorites.reducer';
import {
  TabsReducer,
  TabsState
} from './tabs/tabs.reducer';
import {
  InstrumentReducer,
  InstrumentState
} from './instruments/instrument.reducer';
import {
  ColumnsReducer,
  ColumnsState
} from './columns/columns.reducer';
import {
  FuturesMonitorReducer,
  FuturesState
} from '../futures-monitor/redux/futures-monitor.reducer';
import {
  FuturesReducer,
  FutureState
} from '@iv/store/futures/futures.reducer';
import {
  PermissionReducer,
  PermissionState
} from '@iv/store/permissions/permissions.reducer';

function lastAction(state = null, action) {
  return action;
}

export interface AppState {
  favorites: FavoritesState;
  futuresMonitor: FuturesState;
  tabs: TabsState;
  instruments: InstrumentState;
  futures: FutureState;
  columns: ColumnsState;
  permissions: PermissionState;
  lastAction: (state, action) => {};
}

const rootReducer: Reducer<AppState> = combineReducers<AppState>({
  favorites: FavoritesReducer,
  futuresMonitor: FuturesMonitorReducer,
  tabs: TabsReducer,
  instruments: InstrumentReducer,
  futures: FuturesReducer,
  columns: ColumnsReducer,
  permissions: PermissionReducer,
  lastAction
});

export default rootReducer;
